import 'reflect-metadata'
import './fix'
import { createApp } from 'vue'

import App from './App.vue'
import router from './routes'
import './assets/style/main.css'
import '@patsnap-biz/design-tokens/scss/_variables-RD.css';
import { startup } from '@eureka/startup'
import { headerService } from '@/services/header-service';
import { accountDeferred } from '@eureka/utils/account';
import { registerHttpErrorTooltip } from './infrastructure/utils/register-http-error-tooltip'
import { i18n } from '@/infrastructure/locales'

import _ from 'lodash'

window._ = _;
registerHttpErrorTooltip(i18n.global)

startup({
    headerService,
    projectName: 'eureka',
    preset: {
        name: 'eureka',
    },
    pageInit() {
        return Promise.resolve()
    },
    disableBrowserFavorite: true,
    disableCustomerService: true,
})

accountDeferred.promise.then(
    () => {
        import('@eureka/startup/src/help-center').then(({ getHelpCenter }) => {
            getHelpCenter(i18n.global, headerService)
        })
    }
)

createApp(App).use(router).use(i18n).mount('#app')
